export const validateTokenRequest = {
  message: 'Verification code sent to your email',
  data: {
    email: 'dairoroberto2014@gmail.com',
    token_valid: true
  }
}

export const updatePassword = {
  message: 'Password changed successfully',
  data: {
    email: 'dairoroberto2014@gmail.com'
  }
}
